import { Document, Image, Page } from "@react-pdf/renderer";
import React from "react";

interface IPageImage {
  src: string;
  width: number;
  height: number;
}

interface IPDFContentProps {
  images: IPageImage[];
}

// PDF points: 1pt = 1/72 inch, screen pixels at 96dpi → 1px = 0.75pt
const PX_TO_PT = 0.75;

export const PDFContent: React.FunctionComponent<IPDFContentProps> = ({
  images,
}) => {
  return (
    <Document>
      {images.map(({ src, width, height }, i) => (
        <Page key={i} size={[width * PX_TO_PT, height * PX_TO_PT]}>
          <Image src={src} style={{ width: "100%", height: "100%" }} />
        </Page>
      ))}
    </Document>
  );
};
